/* eslint-disable no-undef */
const config = {
  baseURL: process.env.REACT_APP_APIBASEURL,
  headers: { 'Content-Type': 'application/json' },
  responseType: 'json',
};

export default config;
